<template>
    <div v-if="dataSource && dataSourceType === 'ProtocolDocument'"
        :key="document.id"
        class="p-relative"
    >
        <Toolbar 
            :is-list="false"
            v-on:toolbar-button-click="onToolbarClick"  
        />

        <DocumentPanel :document-info="dataSource.Data.Object" />
        
        <v-tabs
            v-model="tab"
            background-color="transparent"
            slider-size="3"
            class="tab-selector-panel"
            mobile-breakpoint="0"
        >
            <v-tabs-slider color="#E43958"></v-tabs-slider>

            <v-tab 
                v-for="item in pages"
                :key="document.id + item.FormId"
                @click="onTabClicked(item.FormId)"
            >
                <template v-if="item.Count < 0">
                    {{ $t(item.Name) }}
                </template> 
                <template v-else>
                    {{ $t(item.Name) }}
                    <span class="count" id="attachCounter">{{item.Count}}</span>
                </template>   
            </v-tab>

        </v-tabs>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
            <v-tab-item 
                v-for="item in pages"
                :key="document.id + item.FormId"
            >
                <template v-if="item.FormId == document.id">
                    <v-form class="wrapperForm" ref="form" lazy-validation>
                        <v-row dense>

                            <v-col cols="12" sm="12" md="6" class="section-wrapper">

                                <!--Блок Сведения о регистрации-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Сведения_о_регистрации")}}</div>
                                        
                                        <!--Поле Журнал регистрации-->
                                        <v-row no-gutters v-if="isOwnDocument && isRegistered">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Журнал_регистрации")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    {{ document.Counter ? document.Counter.Name : '' }}
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Номенклатура-->
                                        <v-row no-gutters v-if="isOwnDocument">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номенклатура")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : ''" />
                                                <v-select
                                                    v-else
                                                    :value="document.NomenclatureId != guidEmpty ? document.NomenclatureId : null"
                                                    @input="onNomenclatureInput($event)"
                                                    :items="nomenclatures"
                                                    :item-text="item => `${item.Code} ${item.Header}`"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="nomenclatureSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Номер регистрации, дата-->
                                        <v-row no-gutters v-if="!document.is_new_record && isViewMode">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номер_регистрации,_дата")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly :text="concatedRegistrationData" />
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters v-if="!isViewMode">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номер_регистрации")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-text-field
                                                    v-model.trim="RegNumber"
                                                    dense
                                                    outlined
                                                    single-line
                                                    hide-details
                                                    rquired
                                                    :rules="requiredRule"
                                                    maxlength="20"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters v-if="!isViewMode">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Дата_регистрации")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-menu
                                                    v-model="RegDateMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="RegDate | formattedDate"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            outlined
                                                            dense
                                                            rquired
                                                            :rules="requiredRule"
                                                            class="datepick-input"
                                                            hide-details
                                                        >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="RegDate"
                                                        @input="RegDateMenu = false"
                                                        color="teal"
                                                        :min="minRegDate"
                                                        :max="maxRegDate"
                                                        :first-day-of-week="1"
                                                    >
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Регистратор-->
                                        <v-row no-gutters v-if="isRegistered">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Регистратор")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-workplace-chip :id="document.Card.RegistratorWorkplaceId" :name="document.Card.RegistratorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>
                                
                                <!--Блок Реквизиты документа-->
                                <v-card flat>
                                    <v-card-text>

                                        <div class="form-box-title">{{$t("Реквизиты_протокола")}}</div>

                                        <!--поле Тип документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    {{ protocolDocumentTypeName }}
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Тип протокола-->
                                        <v-row v-if="protocolDocumentType === 0" no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_протокола") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Card.ProtocolType ? document.Card.ProtocolType.Value : ''" />
                                                <v-select
                                                    v-else
                                                    :value="document.Card.ProtocolType"
                                                    @input="update({ property: 'Data.Object.Document.Card.ProtocolType', value: $event})"
                                                    :items="protocolTypeItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    dense
                                                    required
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="protocolTypeSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Тип протокола-->
                                        <v-row v-if="protocolDocumentType === 1" no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_протокола") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="personalReceptionType != null ? personalReceptionTypesObject[personalReceptionType] : ''" />
                                                <v-select
                                                    v-else
                                                    :value="document.Card.PersonalReceptionType"
                                                    @input="update({ property: 'Data.Object.Document.Card.PersonalReceptionType', value: $event})"
                                                    :items="personalReceptionTypes"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    hide-details
                                                    outlined
                                                    dense
                                                    required
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Характер вопроса-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Характер_вопроса")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Card.QuestCharacter ? document.Card.QuestCharacter.Value : ''" />
                                                <v-select
                                                    v-else
                                                    :value="document.Card.QuestCharacter"
                                                    @input="update({ property: 'Data.Object.Document.Card.QuestCharacter', value: $event })"
                                                    :items="questCharacterItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="questCharacterSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Язык документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Язык_документа")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <v-field-readonly v-if="isViewMode" :text="document.Card.Languages ? documentLanguages.map((x) => x.Value).join(', ') : ''" />

                                                <v-autocomplete
                                                    v-else
                                                    v-model="documentLanguages"
                                                    :items="GetReference(1000)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    multiple
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="multipleRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>

                                            </v-col>
                                        </v-row>

                                        <!--поле Количество ЛПЭ-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Количество_листов/приложений") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">

                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{`${document.Card.ListCount}/${document.Card.AttachCount}`}}
                                                </div>
                                                <div class="more-inputs-in-row" v-else>
                                                    <v-text-field
                                                        :value="document.Card.ListCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.ListCount', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerNotNull"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                    <span>/</span>
                                                    <v-text-field
                                                        :value="document.Card.AttachCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.AttachCount', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerRule.concat(requiredRule)"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>
                            </v-col>
                            
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">
                                
                                <DocumentStatusCard v-if="!document.is_new_record && isRegistered" :controlInfo="controlInfo" />

                                <!--Секция Корреспондент-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Корреспондент")}}</div>

                                        <!--поле Разработчик поручения-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Разработчик_поручения")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">                                                    
                                                    <div class="onlyReadData">
                                                        <v-enterprise-chip v-if="document.Card.Correspondent.Name" :name="document.Card.Correspondent.Name" />
                                                        <div class="chipAreaNoData" v-if="!document.Card.Correspondent.Name"></div>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Исполнитель-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Исполнитель")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">                                                    
                                                    <div v-if="!isViewMode" @click="onExecuterSelect">
                                                        <v-icon small v-tooltip.left-center="$t('Выбрать_исполнителя')">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        <v-workplace-chip 
                                                            v-if="document.Card.ExecuterName" 
                                                            :id="document.Card.ExecuterWorkplaceId" 
                                                            :name="document.Card.ExecuterName" 
                                                            :canDelete="!isViewMode"                                                            
                                                            :delFunc="onRemoveExecuter"
                                                        />
                                                    </div>
                                                    <div class="chipAreaNoData d-flex align-center pl-1" v-if="!document.Card.ExecuterName && !isViewMode">
                                                        <v-select-members-chip                                            
                                                            target-type="Member"
                                                            @on-select="onSelecExecuterChip"
                                                            :items-params="membersExecuterSelectParams"
                                                            :required="true"
                                                        /> 
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Телефон исполнителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Телефон_исполнителя")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Card.Phone" />
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.Phone"
                                                    @input="update({ property: 'Data.Object.Document.Card.Phone', value: $event })"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <!--Поле За подписью-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("За_подписью")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Card.SignerName" />
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.SignerName"
                                                    @input="update({ property: 'Data.Object.Document.Card.SignerName', value: $event })"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Секция Протокол личного приема-->
                                <v-card v-if="protocolDocumentType === 1" flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Протокол_личного_приема") }}</div>
                                        
                                        <!--Поле Обратившееся лицо-->
                                        <v-row v-if="personalReceptionType === 0" no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Обратившееся_лицо") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Card.AppealPerson" />
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.AppealPerson"
                                                    @input="update({ property: 'Data.Object.Document.Card.AppealPerson', value: $event })"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Адрес заявителя-->
                                        <v-row v-if="personalReceptionType === 0" no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Адрес_заявителя") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Card.AppealPersonAddress" />
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.AppealPersonAddress"
                                                    @input="update({ property: 'Data.Object.Document.Card.AppealPersonAddress', value: $event })"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Суть обращения-->
                                        <v-row v-if="personalReceptionType === 0" no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Суть_обращения") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Card.AppealSubject" />
                                                <v-textarea 
                                                    v-else
                                                    :value="document.Card.AppealSubject"
                                                    @input="update({ property: 'Data.Object.Document.Card.AppealSubject', value: $event })"
                                                    rows="3"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>
                                            </v-col>
                                        </v-row>

                                        <!--Поле Место проведения-->
                                        <v-row v-if="personalReceptionType === 1" no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Место_проведения") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-field-readonly v-if="isViewMode" :text="document.Card.Location" />
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.Location"
                                                    @input="update({ property: 'Data.Object.Document.Card.Location', value: $event })"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Секция Кем создано-->
                                <v-card flat v-if="isViewMode">
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Кем_создано") }}</div>
                                        
                                        <!--поле Сотрудник-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Сотрудник")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-employee-chip :id="document.AuthorId" :name="document.AuthorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Дата создания-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Дата_создания")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ formatDate(document.CreateDate) }}</div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="section-wrapper">

                                <!--Секция Краткое содержание-->
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Краткое_содержание")}}</div>

                                        <!--Поле Краткое содержание-->
                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Краткое_содержание")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div v-if="isViewMode" class="onlyReadData">{{ document.Theme }}</div>
                                                <v-textarea v-else
                                                    :value="document.Theme"
                                                    @input="update({ property: 'Data.Object.Document.Theme', value: $event })"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    class="oneRowStartTextarea"
                                                    rows="3"
                                                    auto-grow
                                                    row-height="16"
                                                >
                                                </v-textarea>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>

                        </v-row>
                    </v-form>
                </template>

                <template v-else-if="!!item && item.FormId == 'Control'">
                    <ControlTab
                        :document="document"
                        :ref="item.FormId"
                    />
                </template>

                <template v-else-if="!!item">
                    <component
                        :is="$mapComponent(item.FormId)" 
                        :ref="item.FormId" 
                        :id="document.id"
                    />
                </template>

            </v-tab-item>
        </v-tabs-items>

        <SendForExecuteDlg v-if="isSendForExecuteDlgVisible" />

    </div>
</template>

<script>
import i18n from '@/i18n'
import sys from '@/services/system';
import { mapActions, mapGetters } from 'vuex';
import Toolbar from '@/components/documents/Toolbar.vue';
import DocumentPanel from '@/components/documents/DocumentPanel.vue';
import DocumentStatusCard from '@/components/documents/DocumentStatus';
import ControlTab from '@/components/documents/tabs/static/Control';
import _ from 'lodash';
import draggable from 'vuedraggable'

export default {
    name: "ProtocolCard",
    components: {
        Toolbar,
        DocumentPanel,
        DocumentStatusCard,
        ControlTab,
        SendForExecuteDlg: () => import('@/components/orders/dialogs/SendForExecutionDlg'),
        draggable
    },
    asyncComputed: {
        questCharacterItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1003 }));

                if (this.questCharacterSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.questCharacterSearch) || i.id == this.document?.Card?.QuestCharacter?.id);
                else
                    return items;
            },
            default: [],
            watch: ['questCharacterSearch']
        },
        protocolTypeItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1035 }));

                if (this.protocolTypeSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.protocolTypeSearch) || i.id == this.document?.Card?.ProtocolType?.id);
                else
                    return items;
            },
            default: [],
            watch: ['protocolTypeSearch']
        },
        nomenclatures : {
            async get() {
                if (this.nomenclatureSearch) {                
                    return (await this.$store.dispatch('documents/references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }))
                        .filter(i => sys.checkSearch(`${i.Code} ${i.Header}`, this.nomenclatureSearch) || i.id == this.nomenclature?.id);
                }
                else
                    return (await this.$store.dispatch('documents/references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }));
            },
            default: [],
            watch: ['nomenclatureSearch']
        }
    },
    computed: {
        ...mapGetters({ requiredRule: 'getRequiredRule', multipleRule: 'getMultipleRule', integerRule: 'getIntegerRule', integerNotNull: 'getIntegerNotNullRule' }),
        ...mapGetters('global/auth', { userEnterpriseId: 'getUserEnterpriseId' }),
        ...mapGetters('global/actionsource', { controlInfo: 'getControlInfo', dataSource: 'getDataSource', dataSourceType: 'getDataSourceType' }),
        ...mapGetters('documents/references', ['GetReference']),
        ...mapGetters('orders', { protocolDocumentTypes: 'getProtocolDocumentTypes', personalReceptionTypes: 'getPersonalReceptionTypes', personalReceptionTypesObject: 'getPersonalReceptionTypesObject' }),
        ...mapGetters('orders/dialogs/sendForExecution', { isSendForExecuteDlgVisible: 'isVisible' }),
        isOwnDocument() {
            if (this.userEnterpriseId != null)
                return this.userEnterpriseId === this.document.EnterpriseId;

            return true;
        },
        isViewMode() {
            return this.dataSource.Data.FormId == "0201141";
        },
        document() {
            return this.dataSource?.Data?.Object?.Document;
        },
        protocolDocumentType() {
            return this.document?.ProtocolDocumentType;
        },
        protocolDocumentTypeName() {
            return this.$t(this.protocolDocumentTypes[this.protocolDocumentType]);
        },
        personalReceptionType() {
            return this.document?.Card?.PersonalReceptionType ?? null;
        },
        guidEmpty() {
            return sys.guidEmpty();
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.document?.id, Name: i18n.t("Карточка") }
            ];

            pages = pages.concat(this.dataSource?.Data?.Object?.Pages ?? []);

            return pages;
        },
        concatedRegistrationData() {
            let result = '';

            if (this.document.Card.RegNumber?.length)
                result = `№ ${this.document.Card.RegNumber}`;

            if (this.document.Card.RegDate)
                result += ` ${this.$t("от_время")} ${this.formatDate(this.document.Card.RegDate)} г.`;

            return result;
        },
        documentLanguages: {
            get: function() {
                return this.document.Card.Languages?.data_list ?? [];
            },
            set: function(newValue) {
                if (this.document.Card.Languages != null)
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages.data_list', value: newValue });
                else
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages', value: { data_list: newValue } });
            }
        },
        //#region регистрационные данные
        isRegistered() {
            return this.document.RegState == 1 || this.document.RegState == 4;
        },
        membersExecuterSelectParams(){
            return {
                includeInner: true,
                includeOuter: this.isORD === true,
                multiple: false,
                selected: [ this.document.Card.ExecuterWorkplaceId ]
            };
        },
        RegDate: {
            get: function() {
                if (this.document.Card.RegDate)
                    return this.$moment(this.document.Card.RegDate).format('YYYY-MM-DD');
                
                return null;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.Document.Card.RegDate', value: `/Date(${Date.parse(newValue)})/` });
            }
        },
        RegNumber: {
            get: function() {
                    return this.document.Card.RegNumber;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.Document.Card.RegNumber', value: newValue });
            }
        },
        minRegDate() {
            return null;
        },
        maxRegDate() {
            return this.$moment(new Date()).format('YYYY-MM-DD');
        },
        //#endregion
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    data () {
        return {
            tab: null,
            //для выбора даты исходящего в режиме редактирования
            RegDateMenu: false,
            //для выбора корреспондента
            correspondentName: null,
            questCharacterSearch: "",
            nomenclatureSearch: "",
            protocolTypeSearch: "",
        }
    },
    methods: {
        ...mapActions('global/actionsource', { updateSource: 'updateDataSource' }),
        //обработка клика по вкладкам документа
        onTabClicked (formId) {
            if (formId === this.document?.id) return;

            let component = this.$refs[formId]?.[0];

            if (component)
                if (typeof component.update === 'function')
                    component.update();
        },
        //обработка клика по тулбару и маппинг в действия хранилища
        async onToolbarClick (event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('global/actionsource/')).map(i => {return i.split('/')[2]})
            
            if (actions.includes(button.Action)) {
                if(button.Action == 'Save' || button.Action == 'SaveAndClose'){
                    let validate_result = this.$refs.form[0].validate();
                    if(validate_result){
                        await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});        
                    }else{
                        this.$notify.alert(i18n.t("Не_заполнены_обязательные_поля"));
                    }
                }
                else
                {
                    await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
                }
            }
            else
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
        },
        onNomenclatureInput(event) {
            this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: event.Code, Header: event.Header } });
            this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: event.id });
        },
        async onExecuterSelect (){
            try {
                let selectMemberParams =  { 
                    title: i18n.t("Выбор_исполнителя"),
                    includeInner: true,
                    includeOuter: this.isORD === true,
                    multiple: false,
                    selected: [ this.document.Card.ExecuterWorkplaceId ]
                }
                let { workplaceId, employeeId, name, contacts } = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);          
                this.onSelecExecuterChip({value: { name, workplaceId, employeeId, contacts } }); 
                /*this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: name });
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: workplaceId });
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: employeeId });

                let phone = contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
                this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });*/
            }
            catch (ex) {
                console.log(ex);
            }
        },
        onSelecExecuterChip(e){
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: e.value.name });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: e.value.workplaceId });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: e.value.employeeId });

            let phone = e.value.contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
        },
        onRemoveExecuter() {
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: null });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: '00000000-0000-0000-0000-000000000000' });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: '00000000-0000-0000-0000-000000000000' });                
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: null });
        },
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },        
        update: _.debounce(function (object) {
            this.updateSource(object);
        }, 250)
    },
    async created() {        
        (async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs?.form?.[0]?.validate();
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs?.form?.[0]?.validate();
        }  
    },
    mounted() {        
        this.$eventBus.$on('set-active-tab', async ({ FormId }) => {
            let page = this.pages.find(x => x.FormId === FormId);

            if (page) {
                let targetIndex = this.pages.indexOf(page);

                if (this.tab != targetIndex)
                    this.tab = targetIndex;
                else
                    this.$eventBus.$emit('update-active-tab');
            }
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('set-active-tab');
    }
}
</script>